import {
  Button as MuiButton,
  ButtonProps,
  CircularProgress,
} from '@mui/material'

interface CustomButtonProps extends ButtonProps {
  loading?: boolean
  width?: number | string
  height?: number | string
}
const Button = ({
  loading = false,
  disabled = false,
  height = 40,
  variant = 'contained',
  children,
  className,
  width = 'auto',
  ref,
  sx,
  ...rest
}: CustomButtonProps) => {
  return (
    <MuiButton
      sx={{
        width: rest.fullWidth ? '100%' : width,
        height,
        textWrap: 'nowrap',
        minWidth: typeof width === 'number' ? width : 80,
        ...sx,
      }}
      variant={variant}
      disabled={disabled}
      className={className}
      {...rest}
    >
      {loading ? (
        <CircularProgress color="inherit" size={20} />
      ) : (
        <>{children}</>
      )}
    </MuiButton>
  )
}

export default Button
